import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'toggle': 'toggle', } };
    }
    toggle(){
        this.el.classList.toggle( 'more' );
        this.call( 'update', false, 'Scroll' );
    }
}
